exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".stopExecutionRenderer_executionRendererIcon__2cGXr{display:flex;flex-direction:row;width:100%;justify-content:space-between}[dir] .stopExecutionRenderer_executionRendererIcon__2cGXr{cursor:pointer;text-align:center}.stopExecutionRenderer_executionRendererIcon__2cGXr:hover{color:#4285f4}.stopExecutionRenderer_infoIcon__1U1VA{color:red}", ""]);

// Exports
exports.locals = {
	"executionRendererIcon": "stopExecutionRenderer_executionRendererIcon__2cGXr",
	"infoIcon": "stopExecutionRenderer_infoIcon__1U1VA"
};